import React from 'react';
import ReactDOM from 'react-dom';

import RenderHeader from 'ViewModels/Components/RenderHeader';

import MyStory from 'ViewModels/Components/MyStory/MyStoryContainer';

ReactDOM.render(<MyStory resources={window.jenkon.resources} />, document.getElementById('main-content'));


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/MyStory.js